import React, {useState} from 'react';

import ComponentErrorBoundary from 'coreComponents/ComponentErrorBoundary';
import {useUI} from 'coreHooks';

import ColorSelectorFlyout from 'brandComponents/flyouts/ColorSelectorFlyout';
import CountrySelectorFlyout from 'brandComponents/flyouts/CountrySelectorFlyout';
import FlyoutAuth from 'brandComponents/flyouts/FlyoutAuth';
import FlyoutFilters from 'brandComponents/flyouts/FlyoutFilters';
import LanguageSelectorFlyout from 'brandComponents/flyouts/LanguageSelectorFlyout';
import MinicartFlyout from 'brandComponents/flyouts/MinicartFlyout';
import QuickSearchFlyout from 'brandComponents/flyouts/QuickSearchFlyout';
import SizeGuideFlyout from 'brandComponents/flyouts/SizeGuideFlyout';
import SizeSelectorFlyout from 'brandComponents/flyouts/SizeSelectorFlyout';
import WishlistFlyout from 'brandComponents/flyouts/WishlistFlyout';

const FlyoutsContainer = () => {
	const openedFlyoutIds = useUI('openedFlyoutIds');
	const sizeSelectorUI = useUI('sizeSelector');
	const sizeGuideUI = useUI('sizeGuide');
	const colorSelectorUI = useUI('colorSelector');

	const [loadedFlyouts, setLoadedFlyouts] = useState({});

	const isFlyoutOpen = (flyoutId: string): boolean => {
		const isOpen = openedFlyoutIds.includes(flyoutId);

		if (isOpen && !loadedFlyouts[flyoutId]) {
			setLoadedFlyouts(
				Object.assign({}, loadedFlyouts, {
					[flyoutId]: true,
				}),
			);
		}

		return isOpen;
	};
	const isFlyoutInPage = (flyoutId: string): boolean => isFlyoutOpen(flyoutId) || loadedFlyouts[flyoutId];
	const isSizeSelectorFlyout = isFlyoutInPage('sizeSelector') || !!sizeSelectorUI?.productID;
	const isColorSelectorFlyout = isFlyoutInPage('colorSelector') || !!colorSelectorUI?.productID;
	const isSizeGuideFlyout =
		isFlyoutInPage('sizeGuide') ||
		!!sizeGuideUI?.sizeGuideId ||
		!!sizeGuideUI?.fitInformation;

	return (
		<>
			{isSizeSelectorFlyout && (
				<ComponentErrorBoundary>
					<SizeSelectorFlyout />
				</ComponentErrorBoundary>
			)}
			{isSizeGuideFlyout && (
				<ComponentErrorBoundary>
					<SizeGuideFlyout />
				</ComponentErrorBoundary>
			)}
			{isFlyoutInPage('minicart') && (
				<ComponentErrorBoundary>
					<MinicartFlyout />
				</ComponentErrorBoundary>
			)}
			{isFlyoutInPage('login') && (
				<ComponentErrorBoundary>
					<FlyoutAuth />
				</ComponentErrorBoundary>
			)}
			{isFlyoutInPage('wishlist') && (
				<ComponentErrorBoundary>
					<WishlistFlyout />
				</ComponentErrorBoundary>
			)}
			{isFlyoutInPage('quickSearch') && (
				<ComponentErrorBoundary>
					<QuickSearchFlyout />
				</ComponentErrorBoundary>
			)}
			{isFlyoutInPage('countrySelector') && (
				<ComponentErrorBoundary>
					<CountrySelectorFlyout />
				</ComponentErrorBoundary>
			)}
			{isFlyoutInPage('languageSelector') && (
				<ComponentErrorBoundary>
					<LanguageSelectorFlyout />
				</ComponentErrorBoundary>
			)}
			{isFlyoutInPage('filters') && (
				<ComponentErrorBoundary>
					<FlyoutFilters />
				</ComponentErrorBoundary>
			)}
			{isColorSelectorFlyout && (
				<ComponentErrorBoundary>
					<ColorSelectorFlyout />
				</ComponentErrorBoundary>
			)}
		</>
	);
};

export default React.memo(FlyoutsContainer);
